exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "mat-toolbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3); }\n  mat-toolbar .as-app-name {\n    margin-left: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/shell/top-bar/top-bar.component.scss
// module id = ../../../../../src/app/shell/top-bar/top-bar.component.scss
// module chunks = main